import React, { useId } from 'react';

// Brand-gradient kebab (three dots) — the overflow-menu icon for investor-web.
// Replaces MUI's solid MoreVert wherever the kebab sits beside the gradient
// Filter / list-card toggle icons, so the whole control group reads as one set.
//
// Same conventions as FilterGradientIcon: 18px default to match its neighbours,
// and useId so several kebabs on one page cannot collide on the gradient id.
const MoreGradientIcon = ({ size = 18, style = {} }) => {
  const id = useId();
  const gradientId = `more_gradient_${id}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block', ...style }}
    >
      {[2.5, 7.5, 12.5].map((cy) => (
        <circle key={cy} cx="7.5" cy={cy} r="1.5" fill={`url(#${gradientId})`} />
      ))}
      <defs>
        <linearGradient
          id={gradientId}
          x1="-3"
          y1="4"
          x2="11"
          y2="18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7852F8" />
          <stop offset="1" stopColor="#84AEF6" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default MoreGradientIcon;
